import {Component, OnInit} from '@angular/core';
import {AdminService} from "../services/admin.service";
import {RoutingstateService} from "../services/routingstate.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {AssetsService} from "../services/assets.service";
import {PagerserviceService} from "../services/pagerservice.service";
import {Location} from "@angular/common";
import {NotificationsService} from "angular2-notifications";
import {PuserserviceService} from "../services/puserservice.service";
import {UserPayload, UserService} from "../services/user.service";
import {BankService} from "../services/bank.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Globals} from "../app-globals";
import * as $ from 'jquery';

@Component({
    selector: 'app-groups',
    templateUrl: './groups.component.html',
    styleUrls: ['./groups.component.css']
})
export class GroupsComponent implements OnInit {
    cArr: Array<any>;
    setCustomerList: {};
    customerListById: {};
    actionListPerformed: Boolean;
    actionViewPerformed: Boolean;

    /* Add New customer */
    customer: Boolean;
    customersList=false;
    editcustomer =false;
    /* Pagination fields */
    // pager Number
    pager: number;

    // pager object
    pager1: any = {};
    Tpager: number;
    // paged items
    pagedItems: Array<any>;

    /*Filter variables*/
    serach:string;
    FilPerpage:number;
    FilPage:number;
    customerid='';

    /* Bank Object */
    banklist = {};

    walletActive:string;
    IPcountry = 'IN';
    /* For Add New Customer Object */
    groupObj = {
        title:'',
        type: 'Admin',
        permission:'read',
        menulist:[],
        _csrf: null,
    };
    updateGroup = {
        _id:'',
        title:'',
        permission:'read',
        menulist:[],
        _csrf: null,
    };
    errorObj = {
        title:'',
        type: '',
        permission: '',
        menu:''
    };

    passclass = 'bar';

    grouplist=[];
    menulist=[];
    fullmenulist=[];
    permission: string;
    childchecked:any=[];

    constructor(private userService: UserService,
                private router: Router,
                private _location: Location,
                private routingState: RoutingstateService,
                private  notifSer: NotificationsService,
                private spinnerService: Ng4LoadingSpinnerService,
                private pusherService:PuserserviceService,
                private assetService:AssetsService,
                private route: ActivatedRoute,
                private pagerService:PagerserviceService,
                private bankService:BankService,
                private adminService:AdminService,
                private global: Globals) { }



    ngOnInit() {
        // check user is logged or not
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission=permData.permission
            })
            this.permission    = this.adminService.getPermission();
            this.customer      = false;
            this.customersList = true;
            this.customerid    = this.route.snapshot.paramMap.get('id');
            this.serach        = '';
            this.FilPerpage    = 10;
            this.FilPage       = 1;
            this.walletActive  = null;
            this.csrf();
            /* Pusher concepts here */
            // this.pusherService.channel.bind('blockville-user', data => {
            //     var dataObj = data.data;
            //     this.setCustomerList = {
            //         'title'  : dataObj.title,
            //         'group'  : dataObj.group,
            //         'type'   : dataObj.type,
            //         'status' : dataObj.status,
            //         '_id'    : dataObj._id,
            //     };

            //     if(this.grouplist){
            //         this.grouplist.unshift(this.setCustomerList);
            //     }else{
            //         this.grouplist = [this.setCustomerList];
            //     }

            //     this.notifSer.success(
            //         'Success',
            //         'New User created',
            //         {
            //             timeOut: 3000,
            //             showProgressBar: true,
            //             pauseOnHover: false,
            //             clickToClose: true,
            //             maxLength: 50
            //         }
            //     )
            // });
            this.pager = 1;
            //this.router.navigateByUrl('adminlist');
            this.getUserGroup();
            this.getMenu();
        
        }
    }

    showCustomerForm() {
        this.customersList = false;
        this.editcustomer = false;
        this.customer = true;
    }
    getMenu() {
        this.adminService.getAdminMenus().subscribe((success) => {
            // this.menulist = success;
            var menulist1 = success;
            this.fullmenulist = success;
            for (let index = 0; index < menulist1.length; index++) {
                if(typeof menulist1[index].parentmenu == 'undefined')
                {
                    if(menulist1[index]['menu'] !=='Manage Announcement' && menulist1[index]['menu'] !=='Content Management System' && menulist1[index]['menu'] !=='Leverage Configuration' && menulist1[index]['menu'] !=='Manage KYC Plan' ){
                        this.menulist.push(menulist1[index])
                    }
                }
            }
            
        }, (error) => {
            this.notifSer.error(
                'User Menu',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    getUserGroup(){
        this.spinnerService.show();
        this.adminService.getGroupList(this.FilPerpage,this.FilPage,this.serach).subscribe((list) => {
            if(list.status){
                this.actionListPerformed = true;
                this.actionViewPerformed = false;
                this.grouplist           = [];
                if(list.customers)
                {
                    for(var i=0;i<list.customers.length;i++)
                    {
                        if(list.customers[i].title!='Customer')
                        {
                            this.grouplist.push(list.customers[i])
                        }
                    }   
                }
                this.Tpager              = list.pages;
                this.setPage(this.FilPage);
            }
            this.spinnerService.hide();
            this.csrf();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'User Group',
                error.error.message,
                {
                    timeOut         : 3000,
                    showProgressBar : true,
                    pauseOnHover    : false,
                    clickToClose    : true,
                    maxLength       : 50
                }
            )
        })
    }
    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.groupObj._csrf    = success._csrf;
            this.updateGroup._csrf = success._csrf;
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut         : 3000,
                    showProgressBar : true,
                    pauseOnHover    : false,
                    clickToClose    : true,
                    maxLength       : 50
                }
            )
        })
    }

    hideCustomerForm() {
        this.editcustomer = false;
        this.customer = false;
        this.customersList = true;
    }
    goBack() {
        this.actionListPerformed = true;
        this.actionViewPerformed = false;

        this.getUserGroup();
    }


    clearError(field) {
        switch (field) {
            case 'title':
                this.errorObj.title = '';
                break;
            case 'type':
                this.errorObj.type = '';
                break;
            case 'permission':
                this.errorObj.permission = '';
                break;
            case 'menu':
                this.errorObj.menu = '';
                break;
        }
    }

    addnewGroup() {
        console.log(this.groupObj);
        
        this.adminService.addNewGroup(this.groupObj).subscribe((success) => {
            //this.router.navigateByUrl('adminlist');
            this.getUserGroup();
            this.groupObj = {
                title:'',
                type: 'Admin',
                permission:'read',
                menulist:[],
                _csrf: null,
            };
            this.notifSer.success(
                'Success',
                'User created',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.hideCustomerForm();

        }, (error) => {
            if (typeof error.error.message === 'object') {
                this.errorObj = error.error.message;
            } else {
                this.notifSer.error(
                    'Error',
                    error.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }
        })
    }

    updateGroupData() {
        console.log(this.updateGroup,'this.updateGroup');
        // return false;
        this.adminService.updateGroup(this.updateGroup).subscribe((success) => {
            //this.router.navigateByUrl('adminlist');
            this.getUserGroup();
            this.notifSer.success(
                'Success',
                'Group Updated',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.updateGroup = {
                _id:'',
                title:'',
                permission:'read',
                menulist:[],
                _csrf: null,
            };
            this.csrf();
            this.hideCustomerForm();
            //this.adminService.toggleGroupUpdate({});

        }, (error) => {
            if (typeof error.error.message === 'object') {
                this.errorObj = error.error.message;
            } else {
                this.notifSer.error(
                    'Error',
                    error.error.message,
                    {
                        timeOut         : 3000,
                        showProgressBar : true,
                        pauseOnHover    : false,
                        clickToClose    : true,
                        maxLength       : 50
                    }
                )
            }
        })
    }
    /* Pagination of customer details */
    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page:number){
        this.pager = page;
        this.FilPage =this.pager;
        this.getUserGroup();
    }


    customerActivate(userId){
        this.spinnerService.show();
        this.adminService.changeGroupStatus(userId,'Active').subscribe(done => {
            this.getUserGroup();
            this.spinnerService.hide();
            this.notifSer.success(
                'Success',
                'Group has been activated',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                err.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    customerDeactivate(userId){
        this.spinnerService.show();
        this.adminService.changeGroupStatus(userId,'Deactive').subscribe(done => {
            this.getUserGroup();
            this.spinnerService.hide();
            this.notifSer.success(
                'Success',
                'Group has been deactivated',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                err.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )

        })
    }
    edit(groupid){
        this.spinnerService.show();
        this.adminService.getGroupById(groupid).subscribe((list) => {
            if(list.length>0) {
                var groupData = list[0];
                this.updateGroup._id = groupData._id;
                this.updateGroup.title = groupData.title;
                this.updateGroup.permission = groupData.permission;
                var rules = groupData['rules'];
                // console.log(this.updateGroup.menulist,'before');
                // console.log(rules,'rules')
                rules.forEach((item)=> {
                    // console.log(item,'item')
                    this.updateGroup.menulist.push({id:item.menu_id,permission:item.permission});
                // console.log(this.updateGroup.menulist,'this.updateGroup.menulist');
                })
                // console.log(this.updateGroup.menulist,'this.updateGroup.menulist');
                console.log(this.menulist,'this.updateGroup.menulist');
                this.customer = false;
                this.customersList = false;
                this.editcustomer = true;
                setTimeout(() => {
                    this.checkAllMenu2();
                }, 1)
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Success',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    delete(groupId) {
        if (window.confirm('Are you sure want to delete this group ?')) {
            this.spinnerService.show();
            this.adminService.groupDelete(groupId).subscribe(done => {
                this.getUserGroup();
                this.spinnerService.hide();
                this.notifSer.success(
                    'Success',
                    'Group has been deleted',
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: true,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: true,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            })
        }
    }

    checkAllMenu2(){
        var checkboxes = document.getElementsByTagName('input')
                    console.log(this.fullmenulist,'this.fullmenulist')
        for(var i=0;i<checkboxes.length; i++){
            if(checkboxes[i].type==='checkbox') {
                var index = this.updateGroup.menulist.findIndex(x => (x.id) === checkboxes[i].getAttribute('value'))
                if ( index !== -1) {
                    var index1 = this.fullmenulist.findIndex(x => (x._id) === checkboxes[i].getAttribute('value'))
                    console.log(index1,'index1')
                    console.log(checkboxes[i].getAttribute('value'),"checkboxes[i].getAttribute('value')")
                    if(index1!=-1 && typeof this.fullmenulist[index1].parentmenu != 'undefined')
                    {
                        console.log(typeof this.fullmenulist[index1].parentmenu,'parentmenu')
                        var parentmenu =  this.fullmenulist[index1].parentmenu;
                        console.log(parentmenu,'parentmenu')
                        $("#upparent_" + parentmenu).prop('checked', true)
                    }
                    checkboxes[i].checked = true;
                    var mnid = 'uppermission_'+checkboxes[i].getAttribute('value');
                    $("input[name='"+mnid+"']").filter('[value="'+this.updateGroup.menulist[index].permission+'"]').attr('checked', true);
                } else {
                    checkboxes[i].checked = false;
                }
            }
        }
    }

    checkAllMenu(element){
        var checkboxes = document.getElementsByTagName('input')
        if(element.target.checked){
            for(var i=1;i<checkboxes.length; i++){
                if(checkboxes[i].type==='checkbox') {
                    checkboxes[i].checked = true;
                    var vall = checkboxes[i].getAttribute('value');
                    $("input[name='permission_"+vall+"']").filter('[value="write"]').attr('checked', true);
                    this.groupObj.menulist = this.arrayRemove(this.groupObj.menulist, checkboxes[i].getAttribute('value'));
                    this.groupObj.menulist.push({id:checkboxes[i].getAttribute('value'),permission:"write"})
                }
            }
        }else{
            for(var i=1;i<checkboxes.length; i++){
                if(checkboxes[i].type==='checkbox') {
                     var vall = checkboxes[i].getAttribute('value');
                    checkboxes[i].checked = false;
                    this.groupObj.menulist = [];
                    $("input[name='permission_"+vall+"']").filter('[value="read"]').attr('checked', false);
                    $("input[name='permission_"+vall+"']").filter('[value="write"]').attr('checked', false);
                }
            }
        }
    }
    checkAllSubMenu(element,id){
        var currentElement = document.getElementById('parent_'+id) as HTMLInputElement;
        var childs=<any> document.getElementsByName('menu_'+id);
        if(element.target.checked){
            this.groupObj.menulist=this.arrayRemove(this.groupObj.menulist,id);
            this.groupObj.menulist.push({id:id,permission:"write"});
            currentElement.checked = true;
            if(childs.length>0) {
                for(var i=0;i<childs.length; i++){
                    childs[i].checked = true;
                    this.groupObj.menulist=this.arrayRemove(this.groupObj.menulist,childs[i].getAttribute('value'));
                    this.groupObj.menulist.push(childs[i].getAttribute('value'))
                }
            }

        }else{
            this.groupObj.menulist=this.arrayRemove(this.groupObj.menulist,id);
            currentElement.checked = false;
            if(childs.length>0) {
                for(var i=0;i<childs.length; i++){
                    childs[i].checked = false;
                    this.groupObj.menulist=this.arrayRemove(this.groupObj.menulist,childs[i].getAttribute('value'));
                }
            }
        }
    }
    checkParentMenu(element,id,pid){
        var currentElement = document.getElementById('child_'+id) as HTMLInputElement;
        var currentParentElement = document.getElementById('parent_'+pid) as HTMLInputElement;
        var childs=<any> document.getElementsByName('menu_'+pid);
        if(element.target.checked){
            this.childchecked.push(id);
            this.groupObj.menulist=this.arrayRemove(this.groupObj.menulist,id);
            this.groupObj.menulist.push({id:id,permission:"write"});
            currentElement.checked = true;
            var flag=true;
            // for(var i=0;i<childs.length; i++){
            //     if(!childs[i].checked){
            //         flag=false;
            //     }
            // }
            console.log(this.childchecked.length);
                if( this.childchecked.length < 0){
                    flag = false;
                }
            if(flag){
                this.groupObj.menulist.push(pid);
                currentParentElement.checked = true;
            }
        }else{
            var index = this.childchecked.indexOf(id)
            this.childchecked.splice(index, 1);
            this.groupObj.menulist=this.arrayRemove(this.groupObj.menulist,id);
            currentElement.checked = false;
            var flag=true;
            // for(var i=0;i<childs.length; i++){
            //     if(!childs[i].checked){
            //         flag=false;
            //     }
            // }
            if( this.childchecked.length == 0){
                flag = false;
            }
            if(!flag){
                this.groupObj.menulist=this.arrayRemove(this.groupObj.menulist,pid);
                currentParentElement.checked = false;
            }
        }
    }

    checkAllMenuUpdate(element){
        var checkboxes = document.getElementsByTagName('input');
        if(element.target.checked){
                    this.updateGroup.menulist = [];
            for(var i=1;i<checkboxes.length; i++){
                if(checkboxes[i].type==='checkbox') {
                    checkboxes[i].checked = true;
                    this.updateGroup.menulist = this.arrayRemove(this.updateGroup.menulist, checkboxes[i].getAttribute('value'));
                    this.updateGroup.menulist.push({id:checkboxes[i].getAttribute('value'),permission:'write'});
                    var vall = checkboxes[i].getAttribute('value');
                     $("input[name='uppermission_"+vall+"']").filter('[value="write"]').attr('checked', true);
                }
            }
        }else{
            for(var i=1;i<checkboxes.length; i++){
                if(checkboxes[i].type==='checkbox') {
                    checkboxes[i].checked = false;
                     var vall = checkboxes[i].getAttribute('value');
                    this.updateGroup.menulist = [];
                     $("input[name='uppermission_"+vall+"']").filter('[value="read"]').attr('checked', false);
                    $("input[name='uppermission_"+vall+"']").filter('[value="write"]').attr('checked', false);
                }
            }
        }
    }
    checkAllSubMenuUpdate(element,id){
        // console.log(this.updateGroup.menulist,'this.updateGroup.menulist')
        var currentElement = document.getElementById('upparent_'+id) as HTMLInputElement;
        var childs=<any>document.getElementsByName('upmenu_'+id);
        if(element.target.checked){
            var menindex = this.menulist.findIndex(x => (x._id) === id);
            console.log(menindex,'menindexmenindexmenindex');
            if(menindex!= -1)
            {
                var sumenlist = this.menulist[menindex];
                var childs = sumenlist.submenu;
                console.log(sumenlist,'menulist')
                if(childs.length>0) {
                    for(var i=0;i<childs.length; i++){
                    var subid =  childs[i]._id;
                   $("#upchild_" + subid).prop('checked', true)
                    this.arrayRemove(this.updateGroup.menulist,subid);
                    this.updateGroup.menulist.push({id:subid,permission:"write"})
                     console.log(this.updateGroup.menulist,'afterthis.updateGroup.menulist')

                    }
                } 
            }
            this.arrayRemove(this.updateGroup.menulist,id);
            this.updateGroup.menulist.push({id:id,permission:"write"});
            console.log(this.updateGroup.menulist,'inchangefunction')
            currentElement.checked = true;
            

        }else{
            this.arrayRemove(this.updateGroup.menulist,id);
            currentElement.checked = false;
            
            var menindex = this.menulist.findIndex(x => (x._id) === id);
            if(menindex!= -1)
            {
                var sumenlist = this.menulist[menindex];
                var childs = sumenlist.submenu;
                console.log(sumenlist,'menulist')
                if(childs.length>0) {
                    for(var i=0;i<childs.length; i++){
                    var subid =  childs[i]._id;
                   $("#upchild_" + subid).prop('checked', false)
                    this.arrayRemove(this.updateGroup.menulist,subid);
                    }
                } 
            }
             console.log(this.updateGroup.menulist,'inchangefunctionelse')
        }
    }
    checkParentMenuUpdate(element,id,pid){        
        var currentElement = document.getElementById('upchild_'+id) as HTMLInputElement;
        var currentParentElement = document.getElementById('upparent_'+pid) as HTMLInputElement;
        var childs=<any>document.getElementsByName('upmenu_'+pid);
        if(element.target.checked){
            this.childchecked.push(id);
            this.updateGroup.menulist=this.arrayRemove(this.updateGroup.menulist,id);
            this.updateGroup.menulist.push({id:id,permission:"write"});
            currentElement.checked = true;
            var flag=true;
                console.log(this.childchecked.length);
                if( this.childchecked.length < 0){
                    flag = false;
                }

            if(flag){
                this.updateGroup.menulist.push({id:pid,permission:"write"});
                currentParentElement.checked = true;
            }
        }else{
            var index = this.childchecked.indexOf(id)
            this.childchecked.splice(index, 1);
            this.updateGroup.menulist=this.arrayRemove(this.updateGroup.menulist,id);
            currentElement.checked = false;
            var flag=true;
            if( this.childchecked.length == 0){
                flag = false;
            }
            $("input[name='uppermission_"+id+"']").filter('[value="read"]').attr('checked', false);
            $("input[name='uppermission_"+id+"']").filter('[value="write"]').attr('checked', false);
            if(!flag){
                this.updateGroup.menulist=this.arrayRemove(this.updateGroup.menulist,pid);
                currentParentElement.checked = false;
            }
        }
    }

    arrayRemove(arr,value) {
        var index       = arr.findIndex(x => (x.id) === value);
        return (index==-1)?arr:arr.splice(index,1);

        // return arr.filter(function(ele){
        //     return ele != value;
        // });
    }
    /**
     * 
     * @param event 
     * @param permission 
     */
    onSelectionChange(event,permission,id,parent){
        console.log(event.target.value,'change value');
        console.log(permission,'permission')
        console.log(id,'permission')
        console.log(this.groupObj);
        var index       = this.groupObj.menulist.findIndex(x => (x.id) === id);
        (parent!='')?$("#parent_" + parent).prop('checked', true):$("#parent_" + id).prop('checked', true);
        $("#child_" + id).prop('checked', true);
        // document.getElementById("parent_"+id).checked = true;
//         radiobtn = document.getElementById("theid");
// radiobtn.checked = true;
        if(index!=-1)
        {
            this.groupObj.menulist[index].permission = permission;
        }
        else
        {
            this.groupObj.menulist.push({id:id,permission:permission})
        }
        
    }
    /**
     * 
     * @param event 
     * @param permission 
     */
    onSelectionChangeUpdate(event,permission,id,parent){
        var index       = this.updateGroup.menulist.findIndex(x => (x.id) === id);
        var parindex       = this.updateGroup.menulist.findIndex(x => (x.id) === parent);
        (parent!='')?$("#upparent_" + parent).prop('checked', true):$("#upparent_" + id).prop('checked', true);
        $("#upchild_" + id).prop('checked', true);
        if(parindex!=-1 && parent!=''){
            this.updateGroup.menulist[parindex].permission = permission;
        }
        else if(parent!='')
        {
            this.updateGroup.menulist.push({id:parent,permission:permission})
        }
        if(index!=-1)
        {
            this.updateGroup.menulist[index].permission = permission;
        }
        else
        {
            this.updateGroup.menulist.push({id:id,permission:permission})
        }
        
    }
    onSelectionAll(event,permission,id,parent){
       

    }
}



// WEBPACK FOOTER //
// ./src/app/groups/groups.component.ts